import { Request } from "@cttq/cttq-request";
import type { CancelToken } from "axios";
import type { PersonSelector } from "../types/index";

const http = new Request({
  baseURL: import.meta.env.VITE_ORG_URL,
  responseInterceptors:(res:any) => res.data
});
/**
 * 获取所有组织
 */
export const getAllDept = () =>
  http.get<PersonSelector.AllDeptTree>({
    url: "org/getAllDept",
  });

/**
 * 获取所有组织
 * @param orgId 组织id
 * @returns
 */
export const getAllDeptPersons = (orgId: string) =>
  http.get<PersonSelector.AllDeptAndPerson>({
    url: "org/person/getAllDeptPersons",
    params: {
      orgId,
      classifyCode: 1,
      isAdministrative: 1,
    },
  });

export const selDepartAndPersons = (
  keyword: string,
  personPageNo: number,
  cancelToken?: CancelToken
) =>
  http.post<PersonSelector.SearchResult>({
    url: "org/classify/selDepartAndPersons",
    cancelToken,
    data: {
      classifyCode: "1",
      deptPageNo: 1,
      deptPageSize: 10,
      isAdministrative: "1",
      keyword,
      personPageNo,
      personPageSize: 10,
    },
  });

export const getPersonHrList = (params: string[]) =>
  http.post<any>({
    url: "person/getPersonHrList",
    data: {
      paramType: 2,
      params,
    },
  });
